export const uzTranslations = {
  // Navigation
  customerIntake: "Mijoz qabuli",
  customerHistory: "Mijoz tarixi",
  labelGeneration: "Yorliq yaratish",
  diagnosticEntry: "Diagnostika",
  accounting: "Buxgalteriya",
  completion: "Yakunlash",
  dailyCashRegister: "Kunlik kassa",

  // Settings
  settingsTitle: "Sozlamalar",
  settingsUpdated: "Sozlamalar muvaffaqiyatli yangilandi",
  smsNotificationsTitle: "SMS xabarnomalar",
  smsNotificationsToggleTitle: "SMS xabarnomalarni yuborish",
  smsNotificationsToggleDesc: "Agar o‘chirilsa, hech qanday holatda SMS xabarlar yuborilmaydi",
  smsNotificationsEnabledHint: "✓ SMS xabarnomalar yoqilgan. Mijozlarga avtomatik xabarlar yuboriladi.",
  smsNotificationsDisabledHint: "⚠ SMS xabarnomalar o‘chirilgan. Hech qanday SMS xabarlar yuborilmaydi.",
  priceFieldTitle: "Narx maydoni",
  priceFieldToggleTitle: "Narx maydonini yashirish",
  priceFieldToggleDesc: "Agar yoqilsa, narx maydoni mijoz qabuli sahifasida yashirin bo‘ladi",
  priceFieldHiddenHint: "✓ Narx maydoni yashirin. Foydalanuvchilar “Ko‘rsatish” tugmasini bosib ko‘rsatishi mumkin.",
  priceFieldVisibleHint: "✓ Narx maydoni ko‘rinadi. Mijoz qabuli sahifasida narx maydoni avtomatik ko‘rsatiladi.",

  // Feedback
  feedbackTitle: "Taklif va so‘rovlar",
  feedbackDesc: "G‘oya, xatolik yoki yangi funksiyani so‘rash uchun yuboring. Xabaringiz Telegram orqali bizga keladi.",
  feedbackAltContact: "Yoki telegram orqali @dev_murod ga (pMaster bo‘yicha) taklifingizni yuboring.",
  feedbackSubmitted: "Rahmat! Xabaringiz yuborildi.",
  feedbackSubmitFailed: "Yuborishda xatolik. Iltimos, qayta urinib ko‘ring.",
  feedbackMessageRequired: "Xabar matnini kiriting",
  feedbackTypeLabel: "Turi",
  feedbackTypeSuggestion: "Taklif",
  feedbackTypeBug: "Xatolik",
  feedbackTypeRequest: "So‘rov",
  feedbackTypeOther: "Boshqa",
  feedbackContactLabel: "Kontakt (ixtiyoriy)",
  feedbackContactPlaceholder: "Telefon, Telegram username, email",
  feedbackMessageLabel: "Xabar",
  feedbackMessagePlaceholder: "G‘oyangiz yoki muammoni batafsil yozing...",
  feedbackRateLimitHint: "Limit: 1 soatda 3 ta xabar",

  // Telegram Reports
  telegramReportsTitle: "Telegram hisobotlar",
  telegramReportsDesc: "Telegram bot orqali kunlik biznes hisobotlarini oling. Hisobingizni bog'lash uchun botni boshlang.",
  telegramLinkButton: "Telegram'ni bog'lash",
  telegramUnlinkButton: "Bog'lanishni olib tashlash",
  telegramLinkedStatus: "Telegram hisobi bog'langan",
  telegramNotLinkedStatus: "Telegram hisobi bog'lanmagan",
  telegramLinkedAt: "Bog'langan",
  telegramLinking: "Bog'lanmoqda...",
  telegramLinkInstructions: "Bot ochildi. Bog'lanishni yakunlash uchun Telegram'da botni boshlang.",
  telegramLinkSuccess: "Hisob muvaffaqiyatli bog'landi!",
  telegramLinkFailed: "Bog'lanishda xatolik. Iltimos, qayta urinib ko'ring.",
  telegramUpdateFailed: "Sozlamalarni yangilashda xatolik",
  telegramReportTimeLabel: "Hisobot vaqti (Toshkent)",
  telegramReportTimeHint: "Kunlik hisobotlar shu vaqtda yuboriladi",
  telegramReportEnabledLabel: "Kunlik hisobotlarni yoqish",
  telegramReportEnabledDesc: "Telegram orqali kunlik biznes statistikasini oling",
  telegramReportEnabledHint: "✓ Kunlik hisobotlar yoqilgan. Hisobotlar tanlangan vaqtda yuboriladi.",
  telegramReportDisabledHint: "Kunlik hisobotlar o'chirilgan. Yoqish uchun tugmani bosing.",
  telegramTestButton: "Test hisobot yuborish",
  telegramTestSending: "Yuborilmoqda...",
  telegramTestFailed: "Test hisobot yuborishda xatolik",

  // Data Export
  dataExportTitle: "Ma'lumotlarni eksport qilish",
  dataExportDesc: "Barcha biznes ma'lumotlaringizni ZIP arxiv sifatida eksport qiling (XLSX fayllar va JSON zaxira bilan). Narx: har bir eksport uchun 5,000 UZS.",
  googleDriveConnected: "Google Drive ulangan",
  googleDriveNotConnected: "Google Drive ulanmagan",
  googleDriveConnectedDesc: "Eksportlar avtomatik ravishda Google Drive'ga yuklanadi",
  googleDriveNotConnectedDesc: "Eksportlarni avtomatik yuklash uchun Google Drive'ni ulang",
  googleDriveConnectButton: "Google Drive'ni ulash",
  googleDriveConnecting: "Ulanmoqda...",
  googleDriveDisconnectButton: "Google Drive'ni uzish",
  googleDriveError: "Google Drive ulanishda xatolik",
  googleDriveConnectError: "Google Drive'ni ulashda xatolik",
  googleDriveDisconnectError: "Google Drive'ni uzishda xatolik",
  exportCost: "Eksport narxi",
  insufficientBalanceExport: "Balans yetarli emas. Joriy balans: {{balance}} UZS",
  currentBalanceExport: "Joriy balans: {{balance}} UZS",
  exporting: "Eksport qilinmoqda...",
  exportDownload: "Eksportni yuklab olish",
  exportToDrive: "Google Drive'ga eksport qilish",
  exportError: "Eksport qilishda xatolik",
  exportHistory: "So'nggi eksportlar",
  toGoogleDrive: "Google Drive'ga",
  view: "Ko'rish",

  // Common
  loading: "Yuklanmoqda...",
  save: "Saqlash",
  cancel: "Bekor qilish",
  submit: "Yuborish",
  search: "Qidirish",
  edit: "Tahrirlash",
  delete: "O'chirish",
  back: "Orqaga",
  next: "Keyingi",
  previous: "Oldingi",
  close: "Yopish",
  open: "Ochish",
  yes: "Ha",
  no: "Yo'q",
  ok: "OK",
  error: "Xatolik",
  success: "Muvaffaqiyat",
  warning: "Ogohlantirish",
  info: "Ma'lumot",

  // Auth
  signIn: "Kirish",
  signOut: "Chiqish",
  signUp: "Ro'yxatdan o'tish",
  signInWithGoogle: "Google orqali kirish",
  continueWithGoogle: "Google orqali davom etish",
  email: "Email",
  password: "Parol",
  confirmPassword: "Parolni tasdiqlang",
  forgotPassword: "Parolni unutdingizmi?",
  resetPassword: "Parolni tiklash",
  resetPasswordTitle: "Parolni tiklash",
  resetPasswordDesc: "Quyida yangi parolingizni kiriting",
  newPassword: "Yangi parol",
  confirmNewPassword: "Yangi parolni tasdiqlang",
  passwordResetSuccess: "Parol muvaffaqiyatli tiklandi! Endi yangi parol bilan kira olasiz.",
  passwordResetError: "Parolni tiklashda xatolik. Qaytadan urinib ko'ring.",
  sendResetEmail: "Tiklash xatini yuborish",
  resetEmailSent: "Parolni tiklash xati yuborildi! Pochtangizni tekshiring.",
  resetEmailError: "Xat yuborishda xatolik. Qaytadan urinib ko'ring.",
  rememberMe: "Meni eslab qol",
  createAccount: "Hisob yaratish",
  alreadyHaveAccount: "Hisobingiz bormi?",
  dontHaveAccount: "Hisobingiz yo'qmi?",
  signingIn: "Kirilmoqda...",
  creatingAccount: "Hisob yaratilmoqda...",

  // Business Setup
  setupBusiness: "Biznesni sozlash",
  setupBusinessDesc: "Biznes ma'lumotlaringizni kiriting",
  businessName: "Biznes nomi",
  businessNamePlaceholder: "Masalan: Tech Repair Service",
  location: "Manzil",
  locationPlaceholder: "Masalan: Toshkent, O'zbekiston",
  saveBusiness: "Biznesni saqlash",
  saving: "Saqlanmoqda...",

  // Customer Intake
  customerInformation: "Mijoz ma'lumotlari",
  customerName: "Mijoz ismi",
  phoneNumber: "Telefon raqami",
  searchOrEnterNewName: "Qidiring yoki yangi ism kiriting",
  searchOrEnterNewNumber: "Qidiring yoki yangi raqam kiriting",
  deviceInformation: "Qurilma ma'lumotlari",
  deviceType: "Qurilma turi",
  deviceModel: "Qurilma modeli",
  issueDescription: "Muammo tavsifi",
  submitAndGenerateLabel: "Yuborish va yorliq yaratish",
  submitting: "Yuborilmoqda...",

  // Device Types
  laptop: "Noutbuk",
  printer: "Printer",
  monitor: "Monitor",
  other: "Boshqa",

  // Form Validation
  nameRequired: "Ism kiritish shart",
  phoneRequired: "Telefon raqami kiritish shart",
  invalidPhone: "Telefon raqami noto'g'ri. O'zbekiston raqami kiriting.",
  phoneIncomplete: "Telefon raqami to'liq emas",
  deviceTypeRequired: "Qurilma turini tanlash shart",
  deviceModelRequired: "Qurilma modelini kiritish shart",
  serialNumberRequired: "Seriya raqamini kiritish shart",
  issueDescriptionRequired: "Muammo tavsifini kiritish shart",

  // Status
  accepted: "Qabul qilingan",
  diagnosed: "Diagnostika qilingan",
  fixed: "Tayyor",
  picked: "Olib ketilgan",
  cancelled: "Bekor qilingan",

  // Financial
  income: "Daromad",
  expenses: "Xarajatlar",
  balance: "Balans",
  amount: "Summa",
  total: "Jami",
  paid: "To'langan",
  due: "Qarz",
  price: "Narx",
  estimatedCost: "Taxminiy narx",
  showPriceField: "Narx maydonini ko'rsatish",
  hidePriceField: "Narx maydonini yashirish",
  paymentMethod: "To'lov usuli",
  creditCard: "Kredit karta",
  debitCard: "Debet karta",
  cash: "Naqd pul",
  bankTransfer: "Bank o'tkazmasi",

  // Time periods
  today: "Bugun",
  yesterday: "Kecha",
  thisWeek: "Bu hafta",
  thisMonth: "Bu oy",
  date: "Sana",
  time: "Vaqt",

  // Landing page
  heroTitle: "Kompyuter, Printer, Macbook, Maishiy texnikalar va boshqalar ta'mirlash",
  proMasters: "Pro Masterlar",
  forCRM: "uchun boshqaruv tizimi",
  heroDescription: "Kompyuter, Printer, Macbook, Maishiy texnikalar va boshqalar ta'mirlash",
  getStartedFree: "Bepul boshlash",
  viewFeatures: "Imkoniyatlarni ko'rish",
  powerfulFeatures: "Kuchli imkoniyatlar",
  choosePlan: "Rejani tanlang",
  freePlan: "Bepul reja",
  premiumPlan: "Premium reja",
  businessPlan: "Biznes reja",
  corporatePlan: "Korporativ",
  corporatePlanDesc: "Ko'p filiallar, maxsus integratsiyalar va ajratilgan qo'llab-quvvatlash bilan katta tashkilotlar uchun",
  forever: "Abadiy",
  perMonth: "oyiga",
  custom: "Maxsus",
  contactUs: "Biz bilan bog'laning",
  popular: "Mashhur",
  upTo10Customers: "10 tagacha mijozlar",
  upTo10Repairs: "10 tagacha ta'mirlashlar",
  freePlanDesc: "Kichik ustaxonalar uchun asosiy funksiyalar",
  premiumPlanDesc: "Barcha funksiyalar cheksiz — professional ustaxonalar uchun",
  upTo100Customers: "100 tagacha mijozlar",
  upTo20Repairs: "20 ta ta'mirlashlar",
  upTo100Repairs: "100 tagacha ta'mirlashlar",
  upTo300Repairs: "300 ta ta'mirlashlar",
  unlimitedRepairs: "Cheklanmagan ta'mirlashlar",
  unlimitedCustomers: "Cheklanmagan mijozlar",
  unlimitedEverything: "Hamma narsa cheklanmagan",
  multiLocationSupport: "Ko'p filial qo'llab-quvvatlash",
  advancedAnalytics: "Kengaytirilgan tahlil va hisobotlar",
  customIntegrations: "Maxsus integratsiyalar",
  dedicatedSupport: "Maxsus qo'llab-quvvatlash jamoasi",
  customBranding: "Maxsus brending",
  apiAccess: "API kirish",
  priorityUpdates: "Ustuvor qo'llab-quvvatlash",
  startManaging: "Ta'mirlash biznesingizni professional boshqarishni boshlang",
  basicRepairTracking: "Asosiy ta'mirlash kuzatuvi",
  qrCodeLabels: "QR kod yorliqlari",
  excelReports: "Excel hisobotlar",
  contactSales: "Savdo bo'limi bilan bog'lanish",
  tryForFree: "Bepul sinab ko'ring",

  // Problems section
  problemsWesolve: "Biz hal qiladigan muammolar",
  problemsSubtitle: "Ustalar har kuni duch keladigan muammolar",
  cashTrackingProblem: "Pul oqimini kuzatish",
  cashTrackingDesc: "Kunlik daromad va xarajatlarni kassadan kuzata olmaslik, bu moliyaviy chalkashlik va daromad yo'qotishga olib keladi.",
  customerManagementProblem: "Mijozlar va ta'mirlashni boshqarish",
  customerManagementDesc: "Mijoz ma'lumotlarini boshqarish va bir nechta ta'mirlashni bir vaqtning o'zida kuzatish qiyinligi, bu muddatni o'tkazib yuborishga olib keladi.",
  smsNotificationProblem: "Mijozlar bilan aloqa",
  smsNotificationDesc: "Ta'mirlash holati haqida mijozlarga qo'ng'iroq qilishga vaqt sarflash, ishlab chiqarishni kamaytiradi.",
  paperworkProblem: "Qog'oz hujjatlari",
  paperworkDesc: "Tartibsiz qog'oz yozuvlari tufayli ta'mirlash ma'lumotlari, mijoz tafsilotlari yoki kafolat hujjatlarini yo'qotish.",
  deviceConditionProblem: "Qurilma holatini hujjatlashtirish",
  deviceConditionDesc: "Mijozlar qurilmani olib kelgandagi holatini va mavjud muammolarni yozib olmaslik, keyinchalik mojaro va tan olmaslikka olib keladi.",

  // Features section
  customerSelfService: "Mijozlar uchun holat kuzatuvi",
  customerSelfServiceDesc: "QR kod orqali mijozlar o'zlari holatni ko'ra oladi, qo'ng'iroq shart emas",
  qrCodeStatusCheck: "QR kod orqali holatni tekshirish",
  publicShopPage: "Ochiq do'kon sahifasi",
  realTimeUpdates: "Real-time yangilanishlar",
  
  pickupFromHome: "Uydan olib ketish",
  pickupFromHomeDesc: "Talab bo'yicha olib ketish xizmati - mijozlar uydan qurilmani olib ketishni so'rashlari mumkin",
  onDemandPickup: "Talab bo'yicha olib ketish xizmati",
  realTimeTracking: "Real-time kuzatuv",
  deliveryIntegration: "Logistika platformasi integratsiyasi",
  
  platformIntegrations: "Platforma integratsiyalari",
  platformIntegrationsDesc: "Barcha kerakli vositalar bilan integratsiya - to'lov, buxgalteriya, elektron tijorat",
  paymentIntegrations: "To'lov integratsiyalari",
  accountingIntegrations: "Masofaviy konsultatsiya",
  ecommerceIntegrations: "Elektron tijorat platformalari",
  
  automaticNotifications: "Avtomatik xabarnomalar",
  automaticNotificationsDesc: "Avtomatik SMS va xabar beruvchi qo'ng'iroqlar - mijozlarga qo'ng'iroq qilish shart emas",
  smsNotifications: "SMS xabarnomalar",
  informingCalls: "Xabar beruvchi qo'ng'iroqlar",
  workflowBased: "Masofaviy diagnostika",
  
  scalableTechStack: "Texnik jihatdan scalable",
  scalableTechStackDesc: "Modern tech stack, multi-tenant ready, API-first approach, cloud-native",
  modernArchitecture: "Zamonaviy arxitektura",
  multiTenantReady: "Multi-tenant tayyor",
  apiFirst: "API-first yondashuv",

  // Common phrases
  backToHome: "Bosh sahifaga qaytish",
  contactSupport: "Qo'llab-quvvatlash bilan bog'laning",
  allRightsReserved: "Barcha huquqlar himoyalangan",
  dashboard: "Boshqaruv paneli",
  editBusiness: "Biznesni tahrirlash",

  // CTA section
  startStreamlining: "Jarayonlarni soddalashtiring",
  joinRepairShops: "Minglab ta'mirlash do'konlari qatoriga qo'shiling",

  // Stats section
  lessAdminWork: "Kam ma'muriy ish",
  digitalTracking: "Raqamli kuzatuv", 
  statusTracking: "Holat kuzatuvi",

  // Sign in page specific
  signInDesc: "Hisobingizga kiring",
  signUpForFree: "Bepul ro'yxatdan o'ting",
  signInInstead: "Kirish",
  noCardRequired: "Karta talab qilinmaydi",
  premiumPaymentNote: "Premium rejani tanlasangiz, to'lov talab qilinadi",
  agreeToTerms: "Davom etish orqali quyidagilarga rozilik bildirasiz:",
  and: "va",

  // Footer
  quickLinks: "Tezkor havolalar",
  legal: "Huquqiy",
  termsOfService: "Foydalanish shartlari",
  privacyPolicy: "Maxfiylik siyosati",
  
  // Additional missing translations
  devicePhotos: "Qurilma rasmlari",
  addPhoto: "Rasm qo'shish",
  devicePhotoNum: "Qurilma rasmi {{num}}",
  photoUploadInfo: "JPEG, PNG yoki WebP formatida, maksimal 5MB. Eng ko'pi 4 ta rasm.",
  unsupportedImageType: "{{name}} fayli qo'llab-quvvatlanmaydi",
  fileTooLarge: "{{name}} fayli juda katta (maksimal 5MB)",
  maxPhotosReached: "Maksimal 4 ta rasm qo'shish mumkin",
  
  // Search and filters
  searchCustomers: "Mijozlarni qidirish",
  searchRepairs: "Ta'mirlashlarni qidirish",
  searchTransactions: "Tranzaksiyalarni qidirish",
  searchByCustomer: "Mijoz bo'yicha qidirish",
  searchByRepairID: "Ta'mirlash ID bo'yicha qidirish",
  searchCustomerName: "Mijoz ismini qidiring",
  searchRepairID: "Ta'mirlash ID ni qidiring",
  searchByRepairIdCustomerNamePhoneDeviceModel: "Ta'mirlash ID, mijoz ismi, mijoz raqami yoki qurilma modeli bo'yicha qidirish",
  
  // Repair status and details
  repairID: "Ta'mirlash ID",
  customer: "Mijoz",
  device: "Qurilma",
  issue: "Muammo",
  status: "Holat",
  createdAt: "Yaratilgan",
  
  // Label generation
  labelPreview: "Yorliq ko'rinishi",
  repairDetails: "Ta'mirlash tafsilotlari",
  downloadLabel: "Yorliqni pechat qilish",
  generatingLabel: "Yorliq yaratilmoqda...",
  backToCustomerIntake: "Mijoz qabuliga qaytish",
  newRepair: "Yangi ta'mirlash",
  latestRepairs: "So'nggi ta'mirlashlar",
  searchResults: "Qidiruv natijalari",
  noRepairsFound: "Ta'mirlashlar topilmadi",
  noRecentRepairs: "So'nggi ta'mirlashlar yo'q",
  
  // Diagnostic
  selectRepair: "Ta'mirlashni tanlang",
  diagnosticDetails: "Diagnostika tafsilotlari",
  reportedIssue: "Xabar qilingan muammo",
  estimatedTime: "Taxminiy vaqt",
  requiredParts: "Kerakli qismlar",
  diagnosticNotes: "Diagnostika eslatmalari",
  partNumbersPlaceholder: "Qism raqamlari yoki tavsifi",
  enterDiagnosticFindings: "Diagnostika natijalarini kiriting",
  completeDiagnostic: "Diagnostikani yakunlash",
  completing: "Yakunlanmoqda...",
  noPendingRepairs: "Kutilayotgan ta'mirlashlar yo'q",
  invalidTime: "Noto'g'ri vaqt",
  invalidCost: "Noto'g'ri narx",
  notesRequired: "Eslatmalar kiritish shart",
  
  // Accounting
  servicedAmount: "Xizmat ko'rsatilgan summa",
  paidAmount: "To'langan summa",
  balanceDue: "Qarz balansi",
  paymentDetails: "To'lov tafsilotlari",
  paymentAmount: "To'lov summasi",
  enterAmount: "Summani kiriting",
  paymentNotes: "To'lov eslatmalari",
  addPaymentNotes: "To'lov eslatmalarini qo'shing",
  recordPayment: "To'lovni qayd qilish",
  recording: "Qayd qilinmoqda...",
  selectRepairPayment: "To'lov uchun ta'mirlashni tanlang",
  noRepairsWithPayments: "To'lovli ta'mirlashlar yo'q",
  
  // Completion
  completionChecklist: "Yakunlash ro'yxati",
  repairsCompleted: "Ta'mirlashlar yakunlandi",
  qualityAssurance: "Sifat nazorati",
  deviceCleaned: "Qurilma tozalandi",
  finalInspection: "Yakuniy tekshiruv",
  completionNotes: "Yakunlash eslatmalari",
  enterCompletionNotes: "Yakunlash eslatmalarini kiriting",
  customerNotification: "Mijozga xabar berish",
  repairCompletedMessage: "Sizning qurilmangiz ta'mirlandi va olib ketishga tayyor. Jami summa: ${{amount}}",
  markNotificationSent: "Xabar yuborilgan deb belgilash",
  completeRepair: "Ta'mirlashni yakunlash",
  cancelRepair: "Ta'mirlashni bekor qilish",
  cancelling: "Bekor qilinmoqda...",
  confirmCancellation: "Bekor qilishni tasdiqlang",
  cancelRepairWarning: "Bu ta'mirlash bekor qilinadi. Hozir kiritilgan eslatmalar bekor qilish sababi sifatida saqlanadi.",
  keepRepair: "Ta'mirlashni saqlash",
  confirmCancel: "Bekor qilishni tasdiqlash",
  noRepairsForCompletion: "Yakunlash uchun ta'mirlashlar yo'q",
  selectRepairToComplete: "Yakunlash uchun ta'mirlashni tanlang",
  cancelDiagnosticTitle: "Diagnostikani bekor qilish",
  cancelDiagnosticWarning: "Haqiqatan ham diagnostikani bekor qilmoqchimisiz? Hozir kiritilgan eslatmalar bekor qilish sababi sifatida saqlanadi.",
  cancelDiagnosticKeep: "Yo'q, davom etish",
  cancelDiagnosticConfirm: "Ha, bekor qilish",
  repairTimeline: "Ta'mirlash tarixi",
  currentStatusDate: "Joriy holat",
  acceptedOn: "Qabul qilingan",
  diagnosedOn: "Diagnostika qilingan",
  fixedOn: "Tayyor bo'lgan",
  pickedOn: "Olib ketilgan",
  cancelledOn: "Bekor qilingan",
  
  // Services
  providedServices: "Ko'rsatilgan xizmatlar",
  addService: "Xizmat qo'shish",
  quickAddServices: "Tezkor qo'shish",
  serviceName: "Xizmat nomi",
  totalServiceCost: "Jami xizmat narxi",
  noServicesAdded: "Hech qanday xizmat qo'shilmagan",
  addServicesDescription: "Bajarilgan xizmatlar va ularning narxini qo'shing",

  // Daily Cash
  addTransaction: "Tranzaksiya qo'shish",
  type: "Turi",
  description: "Tavsif",
  enterDescription: "Tavsifni kiriting",
  period: "Davr",
  noTransactionsFound: "Tranzaksiyalar topilmadi",
  invalidAmount: "Noto'g'ri summa",
  incomeTypeRequired: "Daromad turini tanlash shart",
  customIncomeTypeRequired: "Daromad turini kiriting",
  expenseTypeRequired: "Xarajat turini tanlash shart",
  customExpenseTypeRequired: "Xarajat turini kiriting",
  expense: "Xarajat",
  
  // Customer History
  customerSince: "Mijoz bo'lgan vaqt",
  showFilters: "Filtrlarni ko'rsatish",
  hideFilters: "Filtrlarni yashirish",
  resetFilters: "Filtrlarni qayta o'rnatish",
  startDate: "Boshlanish sanasi",
  endDate: "Tugash sanasi",
  repairStatus: "Ta'mirlash holati",
  diagnosticStatus: "Diagnostika holati",
  all: "Hammasi",
  filterAll: "Barcha holatlar",
  filterDiagnosed: "Sozlanmoqda",
  filterCompleted: "Yakunlangan",
  withDiagnostic: "Diagnostika bilan",
  withoutDiagnostic: "Diagnostikasiz",
  repairHistory: "Ta'mirlash tarixi",
  showingRepairs: "{{shown}}/{{total}} ta'mirlash ko'rsatilmoqda",
  noRepairsMatch: "Hech qanday ta'mirlash mos kelmadi",
  none: "Yo'q",

  // Additional form translations
  selectedPlan: "Tanlangan reja",
  selectPlan: "Rejani tanlash",
  
  // Payme payment
  topupBalance: "Balansni to'ldirish",
  currentBalance: "Joriy balans",
  topupAmount: "To'ldirish miqdori (UZS)",
  minAmount: "Minimal summa: 1,000 UZS",
  payWithPayme: "Payme orqali to'lash",
  processingPayment: "To'lov qayta ishlanmoqda...",
  paymentRedirecting: "Payme to'lov sahifasiga yo'naltirilmoqda...",
  paymentSuccess: "To'lov muvaffaqiyatli amalga oshirildi! Balans to'ldirildi.",
  paymentFailed: "To'lovda xatolik yuz berdi. Iltimos, qayta urinib ko'ring.",
  paymentCancelled: "To'lov bekor qilindi.",
  paymentPending: "To'lov kutilmoqda...",
  invalidAmountError: "Iltimos, to'g'ri miqdorni kiriting",
  paymeNotConfigured: "Payme sozlashda xatolik. Iltimos, administrator bilan bog'laning.",
  
  // Click payment
  payWithClick: "Click orqali to'lash",
  clickNotConfigured: "Click sozlashda xatolik. Iltimos, administrator bilan bog'laning.",
  clickPaymentRedirecting: "Click to'lov sahifasiga yo'naltirilmoqda...",
  selectPaymentMethod: "To'lov usulini tanlang",
  
  // PDF warnings
  cyrillicWarning: "Eslatma: PDFlarda kirill harflari to'g'ri ko'rinmasligi mumkin. Iltimos, lotin yoki o'zbek alifbosi bilan yozing.",
  
  // Balance History
  smsPriceWarning: "Yuborilgan xabarlar turli narxlarda bo'lishi mumkin, yuboriladigan telefon raqam qaysi operatorga tegishli ekanligiga qarab",

  // Plan Limits
  planLimitReached: "Bepul tarif limiti tugadi",
  planLimitReachedDesc: "Siz bepul tarifda barcha {{max}} ta ta'mirdan foydalandingiz. Davom etish uchun Premium tarifga o'ting.",
  planLimitWarning: "Bepul ta'mirlar tugamoqda",
  planLimitWarningDesc: "Sizda {{max}} tadan {{remaining}} ta bepul ta'mir qoldi. Ko'proq ta'mir uchun Premium tarifga o'ting.",
  upgradeToPremium: "Premium tarifga o'tish",
  premiumTrialActive: "Premium sinov davri",
  premiumTrialDesc: "Sizda {{total}} tadan {{remaining}} ta bepul sinov ta'miri qoldi. Keyin obuna talab qilinadi.",
  repairsUsed: "ta ta'mir ishlatildi",

  // Subscription
  subscriptionTitle: "Obuna",
  currentPlan: "Joriy tarif",
  planExpiresOn: "Amal qilish muddati: {{date}}",
  daysLeft: "kun qoldi",
  subscribeToPremium: "Premium tarifga obuna bo'lish",
  renewSubscription: "Obunani yangilash",
  subscriptionCost: "Obuna narxi",
  confirmSubscription: "Balansdan {{amount}} UZS yechiladi. Tasdiqlaysizmi?",
  subscriptionSuccess: "Obuna muvaffaqiyatli faollashtirildi!",
  subscriptionFailed: "Obuna faollashtirishda xatolik yuz berdi",
  insufficientBalanceSubscription: "Balans yetarli emas. Iltimos, avval balansni to'ldiring.",
  subscriptionExpired: "Obuna muddati tugagan",
  subscriptionExpiredDesc: "Premium obuna muddati tugadi. Davom etish uchun obunani yangilang.",
  subscriptionHistory: "Obuna tarixi",
  subscriptionUpgrade: "Premium ga o'tish",
  subscriptionRenewal: "Obunani yangilash",
  subscriptionDowngrade: "Bepul tarifga qaytish",
  subscriptionExpiredAction: "Muddat tugagan",

  // Auto-renewal
  autoRenew: "Avtomatik yangilash",
  autoRenewDesc: "Obuna muddati tugaganda balansdan avtomatik yechiladi",
  autoRenewInsufficientBalance: "Balans yetarli emas — avtomatik yangilash ishlamasligi mumkin",

  // Blog
  blogTitle: "Blog",
  blogDescription: "Ta'mirlash ustaxonalari uchun foydali maqolalar va qo'llanmalar",
  readMore: "Batafsil o'qish",
  publishedOn: "Nashr etilgan",
  backToBlog: "Blogga qaytish",

  // Testimonials
  testimonialsTitle: "Foydalanuvchilar fikrlari",
  testimonialsSubtitle: "O'zbekiston bo'ylab ta'mirlash ustaxonalari pMaster bilan ishlaydi",
  reviews: "ta sharh",

  // Photo source
  photoSourceTitle: "Rasm qo'shish",
  photoSourceCamera: "Kamera",
  photoSourceGallery: "Galereya",
  photoSourceCancel: "Bekor qilish",
  cameraPermissionDenied: "Kameraga ruxsat berilmadi. Iltimos, sozlamalardan ruxsat bering.",
  cameraNotFound: "Kamera topilmadi.",
  cameraError: "Kamerani ishga tushirishda xatolik.",
  tryAgain: "Qayta urinish",

  // Referral
  referralTitle: "Referal dasturi",
  referralCode: "Referal kodi",
  referralCopied: "Nusxa olindi!",
  referralShare: "Ulashish",
  copyLink: "Havolani nusxalash",
  referralTotalInvited: "Taklif qilingan",
  referralCompleted: "Bonus olindi",
  referralTotalBonus: "Jami bonus",
  referralCodeInput: "Referal kodi (ixtiyoriy)",
  referralInvalidCode: "Noto'g'ri referal kodi",
  referralSelfReferral: "O'z kodingizni ishlatib bo'lmaydi",
  referralAlreadyReferred: "Siz allaqachon taklif qilingan",
  referralBonusInfo: "50,000 UZS bonus referalingiz birinchi ta'mir yaratganda hisobingizga tushadi",

  // Landing Page - Problems Section
  problems_label: "MUAMMOLAR",
  problems_title: "Ustalar uchun to'g'ri vositasiz ta'mir do'koni xaos",
  problems_desc: "Pul oqimidan mijoz ma'lumotlarigacha — bu 4 ta muammo biznesingizga har kuni zarar yetkazadi",
  p1_title: "Pul oqimining chalkashligi",
  p1_desc: "Kunlik daromad va xarajatlarni kassadan kuzata olmaslik, bu moliyaviy chalkashlik va daromad yo'qotishga olib keladi.",
  p1_fix: "Raqamli kassa kunlik PDF hisobotlar bilan",
  p2_title: "Yo'qolgan mijoz ma'lumotlari",
  p2_desc: "Mijoz ma'lumotlarini boshqarish va bir nechta ta'mirlashni bir vaqtning o'zida kuzatish qiyinligi, bu muddatni o'tkazib yuborishga olib keladi.",
  p2_fix: "Qidiriladigan raqamli mijozlar bazasi",
  p3_title: "Cheksiz telefon qo'ng'iroqlari",
  p3_desc: "Har kuni mijozlar 'tayyor bo'ladimi?' deb qo'ng'iroq qiladi. Bu vaqtni behuda sarflashga olib keladi.",
  p3_fix: "Avtomatik SMS + ommaviy statuslar sahifasi",
  p4_title: "Qurilma holatini hujjatlashtirish",
  p4_desc: "Mijozlar qurilmani olib kelgandagi holatini va mavjud muammolarni yozib olmaslik, keyinchalik mojaro va tan olmaslikka olib keladi.",
  p4_fix: "Qabul vaqtida fotosuratlar",

  // Landing Page - Features Section
  features_label: "XUSUSIYATLAR",
  features_title: "Zamonaviy ta'mir do'konini boshqarish uchun kerak bo'lgan hamma narsalar",
  features_desc: "Asosiy ta'mirlash operatsiyalarini soddalashtirish va mijozlarga xizmat ko'rsatishni yaxshilash uchun barcha vositalar.",
  f1_title: "Mijoz qabuli va kuzatuvi",
  f1_desc: "Oson mijoz qabuli formasi, ta'mir xizmatlarini boshqarish va holat kuzatuvi.",
  f2_title: "QR Kod Ta'mir Yorliqlar",
  f2_desc: "Har bir ta'mir uchun noyob QR kodlar. Mijoz QR-kodni skanerlab, holatini ko'rishi mumkin.",
  f3_title: "Avtomatik SMS Xabarnomalar",
  f3_desc: "Mijozlarga avtomatik SMS yuborish: qabul qilindi, diagnostika tayyor, yakunlandi.",
  f4_title: "Kunlik Kassa Register",
  f4_desc: "Har kungi daromadni raqamlang — naqd, Payme, Click. Kunlik PDF hisobotlar.",
  f5_title: "Ommaviy Status Sahifasi",
  f5_desc: "Mijozlar o'zlari QR yoki link orqali ta'mir holatini ko'rishadi. Telefonlar kamayadi.",
  f6_title: "Telegram Kunlik Hisobotlar",
  f6_desc: "Kunlik biznes statistikasi Telegram orqali: ta'mirlashlar, daromad, mijozlar soni.",

  // CTA Section
  cta_title: "Tayyorsizmi o'zingizning do'koningizni professional darajada boshqarish uchun?",
  cta_desc: "Hozirda 2 500+ ta'mir do'koni egasi pMaster'dan foydalanmoqda.",
  cta_btn: "Bepul boshlang",

  // Footer
  footer_desc: "pMaster - O'zbekiston bozori uchun maxsus ishlab chiqilgan ta'mir do'koni CRM. Operatsiyalarni soddalashtiring va biznesni rivojlantiring.",
  footer_product: "Mahsulot",
  footer_blog: "Blog",
  footer_company: "Kompaniya",
  footer_about: "Biz haqida",
  footer_privacy: "Maxfiylik siyosati",
  footer_terms: "Foydalanish shartlari",
  footer_contact: "Bog'laning",
  footer_made: "Dunyo bo'ylab ta'mir do'koni egalari uchun mehr bilan tayyorlangan",

  // How It Works Section
  how_label: "JARAYON",
  how_title: "Qanday ishlaydi?",
  how_desc: "Sodda 3 bosqichda ta'mir do'koningizni o'zgartiring",
  s1_title: "Mijozni qabul qiling",
  s1_desc: "Mijozni qabul qilish formasini to'ldiring, qurilma rasmlari va muammoni hujjatlang.",
  s2_title: "Diagnostika va to'lov",
  s2_desc: "Diagnostika natijalarini kiriting, narxni belgilang — mijoz SMS orqali xabardor qilinadi.",
  s3_title: "Yakunlash va tahlil",
  s3_desc: "Ta'mirlashni yakunlang, kunlik hisobotni PDF orqali oling yoki Telegram'da ko'ring.",

  // Device Types Section
  devices_label: "QURILMALAR",
  devices_title: "Har qanday qurilma — barchasini qo'llab-quvvatlaymiz",
  devices_desc: "pMaster har qanday turdagi elektronika va uy texnikasi ta'mirlashni boshqarishi mumkin",

  // FAQ Section
  faq_label: "SAVOL-JAVOBLAR",
  faq_title: "Ko'p so'raladigan savollar",
  q1: "pMaster bepulmi?",
  a1: "Ha, pMaster asosiy xususiyatlarga ega bepul rejani taqdim etadi. Professional ta'mir do'konlari uchun qo'shimcha imkoniyatlarga ega Premium reja ham mavjud.",
  q2: "O'z ma'lumotlarim xavfsiz bo'ladimi?",
  a2: "Ha, barcha ma'lumotlar Supabase orqali shifrlangan holda xavfsiz saqlanadi. Biz GDPR va O'zbekiston ma'lumotlarni himoya qilish qonunchiligiga amal qilamiz.",
  q3: "Qanday to'lovni qabul qila olaman?",
  a3: "pMaster Click va Payme to'lov tizimlari bilan birlashtirilgan - Uzbekistondagi eng mashhur to'lovlar.",
  q4: "Mobil ilovasi mavjudmi?",
  a4: "Ha, pMaster PWA (Progressive Web App) sifatida ishlaydi. Uni to'g'ridan-to'g'ri mobil brauzerda ishlatish mumkin.",
  q5: "Qo'llab-quvvatlash xizmati bormi?",
  a5: "Ha, biz Telegram va email orqali 24/7 qo'llab-quvvatlaymiz. Yangi imkoniyat kerak bo'lsa — so'rang, biz uni qo'shamiz.",
  q6: "Boshqa dasturdan ko'chib o'tsam bo'ladimi?",
  a6: "Albatta! Barcha ma'lumotlarni CSV/XLSX shaklida eksport qila olasiz.",
  q7: "Bu English tilida ham mavjudmi?",
  a7: "Ha, pMaster Uzbek, Rus va English tillarida mavjud. Sozlamalardan tilni o'zgartira olasiz.",
  q8: "Telegramdagi bot nima qiladi?",
  a8: "Telegramdagi bot kunlik hisobotlar, mijoz xabarnomalari va statistika beradi.",

  // Header & Nav
  nav_features: "Imkoniyatlar",
  nav_how: "Qanday ishlaydi",
  nav_pricing: "Narxlar",
  nav_faq: "Savollar",
  header_cta: "Bepul boshlash",

  // Hero
  hero_title: "Ta'mirlash ustaxonangizni professional boshqaring",
  hero_sub: "Ta'mirlash ustaxonalari uchun bepul bulutli CRM. Buyurtmalarni kuzating, mijozlarni avtomatik xabardor qiling va moliyani boshqaring — istalgan qurilmadan.",
  hero_cta: "Bepul boshlash",
  hero_learn: "Batafsil",
  badge_free: "Bepul sinab ko'rish",
  badge_nocard: "Bank kartasi talab qilinmaydi",
  badge_pwa: "Har qanday qurilmada ishlaydi",

  // Hero floating cards
  card_sms: "SMS yuborildi",
  card_sent: "Mijoz xabardor qilindi",
  card_qr: "QR skanerlandi",
  card_scanned: "Holat tekshirildi",
  card_today: "Bugun",
  card_income: "1 250 000 so'm",
  card_daily: "Kunlik daromad",

  // Stats
  stat_shops_label: "Ustaxonalar",
  stat_repairs_label: "Ta'mirlar",
  stat_rating_label: "Reyting",
  stat_uptime_label: "Ish vaqti",

  // CTA
  cta_desc: "2 500+ ustaxona egalariga qo'shiling. Bepul, 5 daqiqada sozlash.",
  cta_btn: "Bepul akkaunt yarating",

  // Footer
  footer_product: "Mahsulot",
  footer_blog: "Blog",
  footer_company: "Kompaniya",
  footer_about: "Biz haqimizda",
  footer_contact: "Aloqa",
  footer_made: "Butun dunyo ustaxona egalari uchun mehr bilan yaratilgan."
};